module.exports = __webpack_public_path__ + "static/doradztwo_podatkowe5-01-0b907838e8ed5f05963203e7df82b2f1.png";